import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class NotificationWorkflow  {
    _originalTypeClassName = "zPMO.BO.NotificationWorkflow";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
NotificationWorkflow.translate = translateService;
}
this.Steps = [];
this.Id = null;
this.Name = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Steps:any;
static setSteps = ($this, items) => {
                if (items == null) items = [];
                if ($this.Steps == null) $this.Steps = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Steps.length > 0) {
                    Domain.NotificationWorkflow.removeSteps($this, $this.Steps[0]);
                }

                Domain.NotificationWorkflow.addManySteps($this, copyItems);
            }
static addManySteps = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.NotificationWorkflow.addSteps($this, items[i]);
                }
            }
static addSteps = ($this, item) => {
                if ($this.Steps == null) $this.Steps = [];
                if (item == null || $this.Steps.indexOf(item) > -1) return;
                $this.Steps.push(item);
}
static addRangeSteps = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.NotificationWorkflow.addSteps($this, item));
            }
static removeSteps = ($this, item) => {
                if ($this == null || $this.Steps == null || $this.Steps.indexOf(item) === -1) return;
                var _index = $this.Steps.indexOf(item);
                $this.Steps.splice(_index, 1);
}
static clearSteps = ($this) => { $this.Steps = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}